






























import { Component, Prop, Vue } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class DatePickerDialog extends Vue {
  @Prop() private value!: string
  @Prop() private textProps?: any
  @Prop() private pickerProps?: any
  private menu: boolean = false
  private date: any = null

  constructor () {
    super()
    this.date = this.value
  }

  public update (date) {
    const menu: any = this.$refs.menu
    menu.save(date)
    this.$emit('input', date)
  }

  get selectedDateDayNumber () {
    return moment(this.value).format('D')
  }
  get selectedDateDayName () {
    return moment(this.value).format('dddd')
  }
  get selectedDateMonthName () {
    return moment(this.value).format('MMMM')
  }
  get selectedDateYearNumber () {
    return moment(this.value).format('YYYY')
  }
}
